import {
	changePage,
	getClaims,
	getClaimsNotifications,
} from 'feature/claims/claimsSlice';
import { FC, Fragment, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	addEventSubscription,
	removeEventSubscription,
	removeSseMessage,
} from 'feature/sseEventManager/sseEventSlice';
import { AppDispatch, RootState } from 'store/store';
import { Typography } from 'styles';
import { Collections } from 'types/Form';
import { SSE_EVENT_TYPE } from 'utils/sse.hook';
import { useTranslation } from 'utils/translations';
import ClaimListFooter from './ClaimListFooter.component';
import Claims from './Claims.component';

const ViewClaims: FC<{ isNotifications?: boolean }> = ({ isNotifications }) => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { page } = useSelector((store: RootState) => store.claims);
	const {
		inputExternalClaimId,
		inputFirstName,
		inputLastName,
		inputCarrierClaimId,
		inputDateOfService,
		inputClaimStatus,
		sortingDirections,
		sortingFields,
		collection,
	} = useSelector((store: RootState) => store.form);

	const searchParams = useMemo(
		() => ({
			inputExternalClaimId,
			inputCarrierClaimId,
			inputFirstName,
			inputLastName,
			inputDateOfService,
			inputClaimStatus,
			sortingDirections,
			sortingFields,
		}),
		[
			inputDateOfService,
			inputExternalClaimId,
			inputCarrierClaimId,
			inputClaimStatus,
			inputFirstName,
			inputLastName,
			sortingDirections,
			sortingFields,
		],
	);

	useEffect(() => {
		if (searchParams && collection === Collections.CLAIMS && page) {
			if (isNotifications) {
				dispatch(
					getClaimsNotifications({
						limit: '8',
						list: true,
					}),
				);
			} else {
				dispatch(
					getClaims({
						limit: '8',
					}),
				);
			}
		}
	}, [dispatch, page, searchParams, collection, isNotifications]);

	useEffect(() => {
		if (searchParams) dispatch(changePage(1));
	}, [dispatch, searchParams]);

	/*************  SSE  ********** */
	const { events } = useSelector((store: RootState) => store.sseEvents);

	useEffect(() => {
		dispatch(addEventSubscription(SSE_EVENT_TYPE.CLAIM));
		return () => {
			dispatch(removeEventSubscription(SSE_EVENT_TYPE.CLAIM));
		};
	}, [dispatch]);

	const { claims } = useSelector((store: RootState) => store.claims);

	useEffect(() => {
		events
			.filter(el => el.type === SSE_EVENT_TYPE.CLAIM)
			.forEach(ev => {
				if (claims.find((el: any) => el.claimUUID === ev.key)) {
					dispatch(getClaims({ showloader: false, limit: '8' }));
					dispatch(removeSseMessage(ev));
				}
			});
	}, [claims, dispatch, events]);
	/*************************** */

	return (
		<Fragment>
			{isNotifications && (
				<Typography variant="title5" margin="24px 0 48px 0">
					{tClientLabels('claimsNotifications.subtitle')}
				</Typography>
			)}
			<Claims />
			<ClaimListFooter />
		</Fragment>
	);
};

export default ViewClaims;
